<template>
    <v-layout class="navmenu-container" justify-center align-center>
        <!-- v-show="screenTrack[0] >= 1"  -->
        <button class="btn-nav" :class="{'inactive': !screenTrack[0] >= 1}" @click="scrolltop()">
                  <router-link :to="'/'+mod.modurl+'/'+ (screenTrack[0]-1)" @click.native.prevent="guardarubicacion()">
                    <div class="icon animated fadeInLeft">
                      <svg xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#"
                        xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg"
                        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
                        xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" viewBox="0 0 48 48" version="1.1" id="svg77"
                        sodipodi:docname="BOTON-ANTERIOR.svg" inkscape:version="0.92.5 (2060ec1f9f, 2020-04-08)">
                        <metadata id="metadata81">
                          <rdf:RDF>
                            <cc:Work rdf:about="">
                              <dc:format>image/svg+xml</dc:format>
                              <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
                            </cc:Work>
                          </rdf:RDF>
                        </metadata>
                        <sodipodi:namedview pagecolor="#ffffff" bordercolor="#666666" borderopacity="1" objecttolerance="10"
                          gridtolerance="10" guidetolerance="10" inkscape:pageopacity="0" inkscape:pageshadow="2"
                          inkscape:window-width="1920" inkscape:window-height="1016" id="namedview79" showgrid="false"
                          inkscape:zoom="4.9166667" inkscape:cx="3.7627119" inkscape:cy="24" inkscape:window-x="0"
                          inkscape:window-y="27" inkscape:window-maximized="1" inkscape:current-layer="svg77" />
                        <defs id="defs2" />
                        <g id="icon-left" inkscape:label="#g1018">
                          <g id="XMLID_80_">
                            <linearGradient gradientUnits="userSpaceOnUse" y2="5.2550001" y1="42.205002" x2="24" x1="24"
                              id="XMLID_87_">
                              <stop id="stop4" stop-color="#f2f6f9" offset="0" />
                              <stop id="stop6" stop-color="#e8f1f7" offset="1" />
                            </linearGradient>
                            <circle style="fill:url(#XMLID_87_)" r="17.700001" cy="24" cx="24" id="XMLID_285_" />
                            <g id="XMLID_85_">
                              <defs id="defs15">
                                <filter filterUnits="userSpaceOnUse" y="0.80000001" x="0.80000001" height="46.400002"
                                  width="46.400002" id="Adobe_OpacityMaskFilter">
                                  <feFlood id="feFlood10" result="back" flood-opacity="1" flood-color="#fff" />
                                  <feBlend mode="normal" id="feBlend12" in2="back" in="SourceGraphic" />
                                </filter>
                              </defs>
                              <mask maskUnits="userSpaceOnUse" y=".8" x=".8" height="46.4" width="46.4" id="SVGID_1_">
                                <g style="filter:url(#Adobe_OpacityMaskFilter)" id="g19">
                                  <image style="overflow:visible" id="image17"
                                    xlink:href="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEASABIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHCAAACOgAAAtv/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIADMAMwMBIgACEQEDEQH/ xACGAAEAAgMBAQAAAAAAAAAAAAAABgcBAwUEAgEBAAAAAAAAAAAAAAAAAAAAABAAAgICAwEBAQAA AAAAAAAAAgQBAwUGABAxQBMHEQABAwIEBAQHAAAAAAAAAAABABECIQMQIEESMVGBImGRsYNxoUKC M0MEEgEAAAAAAAAAAAAAAAAAAABA/9oADAMBAAIRAxEAAACv/WtQiG6yMlLcm86tI8CZ2XXdimQY jEo4BULYOtbNFSgtdHdx2a8+oQagAbtgeUAH/9oACAECAAEFAPg//9oACAEDAAEFAPg//9oACAEB AAEFAOI41p409Etsi7QZEMjrryM+dY1E32sBgKFKBARiYiePY6hmvasJKLHNDTrsIRgR73BELlPx Pn8/OIGPO9quEE/2Dmq5SEXEW62aerbRqHdc3BDyJmJwW3WqcU2xO0LNnTEc7uYyLLNrNvdHh+d/ /9oACAECAgY/AAf/2gAIAQMCBj8AB//aAAgBAQEGPwBbbMaay0W67Il9OCOwyB5onaZwGuqY4Rsx 4fUfBR7QGCaIZVCkDEOUb1uLQJ7hgbpDkn0QA0yTLPQr7tnVNruPrlm/Ir3d/RCEy0ZmnxUZRLls TKRZkbFuVZUwBFCKgoW/6D2igkgTMeaJEx5o27Et0joEbt0vI/LIfye2v39eGT//2Q=="
                                    transform="translate(-1.209,-1.62)" overflow="visible" height="51" width="51" />
                                </g>
                              </mask>
                              <g id="g42" mask="url(#SVGID_1_)">
                                <defs id="defs27">
                                  <filter filterUnits="userSpaceOnUse" y="0.80000001" x="0.80000001" height="46.400002"
                                    width="46.400002" id="Adobe_OpacityMaskFilter_1_">
                                    <feFlood id="feFlood22" result="back" flood-opacity="1" flood-color="#fff" />
                                    <feBlend mode="normal" id="feBlend24" in2="back" in="SourceGraphic" />
                                  </filter>
                                </defs>
                                <mask maskUnits="userSpaceOnUse" y=".8" x=".8" height="46.4" width="46.4" id="mask33">
                                  <g style="filter:url(#Adobe_OpacityMaskFilter_1_)" id="g31">
                                    <image style="overflow:visible" id="image29"
                                      xlink:href="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEASABIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAG8AAACPQAAAr7/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIADMAMwMBIgACEQEDEQH/ xACAAAACAwEBAAAAAAAAAAAAAAAABwIDBgUBAQEAAAAAAAAAAAAAAAAAAAAAEAACAgICAgMAAAAA AAAAAAACAwEEBQYAEEASETETEQABAwIFBAMBAAAAAAAAAAABABECIQMQQVGBEiAxIoJhkTJDEgEA AAAAAAAAAAAAAAAAAABA/9oADAMBAAIRAxEAAABf3+sUy1rNmJbnuNaHHANM0Vqzi0Ajh9zjxZEw 6DSTHeHB7jLjQreWVIAAAWTAoAAA/9oACAECAAEFAPA//9oACAEDAAEFAPA//9oACAEBAAEFAOVa T7RVdScyG6cYjdw1upPVKqVt+A19a1popWJVUlGUwymrz+Kmm/moVQYykkVq6MYIdtoiSvQuaYcC VcolXUz8RtbhhP6DzAX4qWsRkltVBCUTMRy7dWle15b9Z5EzE4jY21JqbYkgdtSfXL7TLIc43H2r hfXf/9oACAECAgY/AAf/2gAIAQMCBj8AB//aAAgBAQEGPwBcbUX+U8yaomLui8TKIzxjajn3UfFA MmZSaKM4hoE1w5kVdBhiQVMtkVvx3THVBsSpvoV78tkBItGRooh04OBqjagaypg47hCF00GaHmPt UmEYWzyJ0RuXC5PQf36L+u/R/9k="
                                      transform="translate(-1.209,-1.62)" overflow="visible" height="51" width="51" />
                                  </g>
                                </mask>
                                <linearGradient gradientUnits="userSpaceOnUse" y2="47.771" y1="0.171" x2="24" x1="24" id="SVGID_2_">
                                  <stop id="stop35" stop-color="#fff" offset="0" />
                                  <stop id="stop37" stop-color="#c1c5dc" offset="1" />
                                </linearGradient>
                                <circle style="fill:url(#SVGID_2_)" id="circle40" r="23.200001" cy="24" cx="24" />
                              </g>
                            </g>
                            <linearGradient gradientUnits="userSpaceOnUse" gradientTransform="matrix(1,0,0,-1,0,-14263.242)"
                              y2="-14305.522" y1="-14269.701" x2="24" x1="24" id="XMLID_88_">
                              <stop id="stop45" stop-color="#fff" offset="0" />
                              <stop id="stop47" stop-color="#d9e7eb" offset="1" />
                            </linearGradient>
                            <circle style="fill:url(#XMLID_88_)" r="17.299999" cy="24" cx="24" id="XMLID_83_" />
                            <g id="XMLID_81_">
                              <defs id="defs56">
                                <filter filterUnits="userSpaceOnUse" y="7.1999998" x="7.1999998" height="33.700001"
                                  width="33.700001" id="Adobe_OpacityMaskFilter_2_">
                                  <feFlood id="feFlood51" result="back" flood-opacity="1" flood-color="#fff" />
                                  <feBlend mode="normal" id="feBlend53" in2="back" in="SourceGraphic" />
                                </filter>
                              </defs>
                              <mask maskUnits="userSpaceOnUse" y="7.2" x="7.2" height="33.7" width="33.7" id="SVGID_3_">
                                <g style="filter:url(#Adobe_OpacityMaskFilter_2_)" id="g60">
                                  <image style="overflow:visible" id="image58"
                                    xlink:href="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEASABIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGqAAAB/wAAAnT/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACcAJwMBIgACEQEDEQH/ xAB+AAADAQEBAQAAAAAAAAAAAAAABQcGBAECAQEAAAAAAAAAAAAAAAAAAAAAEAACAwEAAwEAAAAA AAAAAAAEBQECAwAwEwYVEQACAgACCQUAAAAAAAAAAAABAgARIgMQITFBUXGxEwSh0ZJTFBIBAAAA AAAAAAAAAAAAAAAAMP/aAAwDAQACEQMRAAAAn7P2nGBUWnPkpO8HNPjVLNGu+s8Y4WBxtAGKcDiA P//aAAgBAgABBQDw/wD/2gAIAQMAAQUA8P8A/9oACAEBAAEFAOBRElxf5LWKGqiRJ5EBBZKlTnTO wGM1eJ87Z7h+pn8hNYuFMenm019LKafupTpEJUucrZ2Z4xV68zrnsZOrDgSm2PWaO5odsw1nv//a AAgBAgIGPwAf/9oACAEDAgY/AB//2gAIAQEBBj8AgaioOyWLuEsLUb9ALC1UxcMqhGwxMisL5igD m1TXtuCtBvhPFr7kv5iCzSt1i4pdiNii+STqR1YcgbmqDs5WbmLupWPQSvx5/Ptv7S/JR0HBlIHr o//Z"
                                    transform="translate(4.791,4.38)" overflow="visible" height="39" width="39" />
                                </g>
                              </mask>
                              <g id="g70" mask="url(#SVGID_3_)">
                                <linearGradient gradientUnits="userSpaceOnUse" y2="41.630001" y1="6.2480001" x2="24" x1="24"
                                  id="SVGID_4_">
                                  <stop id="stop63" stop-color="#f2f6f9" offset="0" />
                                  <stop id="stop65" stop-color="#f2f3f4" offset="1" />
                                </linearGradient>
                                <circle style="fill:url(#SVGID_4_)" id="circle68" r="16.799999" cy="24" cx="24" />
                              </g>
                            </g>
                          </g>
                          <g id="icon">
                            <path inkscape:connector-curvature="0" d="M 29.2,17 V 31 L 17.3,24 Z"
                              id="XMLID_78_" />
                          </g>
                        </g>
                      </svg>
                    </div>
                  </router-link>
                </button>
        <div class="progress-container">
            <div class="progress-bar">
                <div ref="progressBar" class="bar"></div>
            </div>
        </div>
        <!-- v-show="nextPant" -->
        <button class="btn-nav" :class="{'inactive': !nextPant}" @click="scrolltop()">
                  <router-link :to="'/'+mod.modurl+'/'+ (screenTrack[0]+1)" @click.native.prevent="guardarubicacion()">
                    <div class="icon animated fadeInRight">
                      <svg xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#"
                        xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg"
                        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
                        xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" viewBox="0 0 48 48" version="1.1" id="svg77"
                        sodipodi:docname="BOTON-SIGUIENTE.svg" inkscape:version="0.92.5 (2060ec1f9f, 2020-04-08)">
                        <metadata id="metadata81">
                          <rdf:RDF>
                            <cc:Work rdf:about="">
                              <dc:format>image/svg+xml</dc:format>
                              <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
                            </cc:Work>
                          </rdf:RDF>
                        </metadata>
                        <sodipodi:namedview pagecolor="#ffffff" bordercolor="#666666" borderopacity="1" objecttolerance="10"
                          gridtolerance="10" guidetolerance="10" inkscape:pageopacity="0" inkscape:pageshadow="2"
                          inkscape:window-width="1920" inkscape:window-height="1016" id="namedview79" showgrid="false"
                          inkscape:zoom="4.9166667" inkscape:cx="1.7288136" inkscape:cy="24" inkscape:window-x="0"
                          inkscape:window-y="27" inkscape:window-maximized="1" inkscape:current-layer="svg77" />
                        <defs id="defs2" />
                        <g id="icon-right" inkscape:label="#g1018">
                          <g id="XMLID_315_">
                            <linearGradient gradientUnits="userSpaceOnUse" gradientTransform="matrix(-1,0,0,1,-2075.483,0)"
                              y2="5.2540002" y1="42.203999" x2="-2099.4829" x1="-2099.4829" id="XMLID_87_">
                              <stop id="stop4" stop-color="#f2f6f9" offset="0" />
                              <stop id="stop6" stop-color="#e8f1f7" offset="1" />
                            </linearGradient>
                            <circle style="fill:url(#XMLID_87_)" r="17.700001" cy="24" cx="24" id="XMLID_325_" />
                            <g id="XMLID_323_">
                              <defs id="defs15">
                                <filter filterUnits="userSpaceOnUse" y="0.80000001" x="0.80000001" height="46.400002"
                                  width="46.400002" id="Adobe_OpacityMaskFilter">
                                  <feFlood id="feFlood10" result="back" flood-opacity="1" flood-color="#fff" />
                                  <feBlend mode="normal" id="feBlend12" in2="back" in="SourceGraphic" />
                                </filter>
                              </defs>
                              <mask maskUnits="userSpaceOnUse" y=".8" x=".8" height="46.4" width="46.4" id="SVGID_1_">
                                <g style="filter:url(#Adobe_OpacityMaskFilter)" id="g19">
                                  <image style="overflow:visible" id="image17"
                                    xlink:href="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEASABIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHFAAACPwAAAub/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIADMAMwMBIgACEQEDEQH/ xACJAAEAAgMBAQAAAAAAAAAAAAAABgcBAwQFAgEBAAAAAAAAAAAAAAAAAAAAABAAAQQCAgMBAQAA AAAAAAAABAECAwYABRARQDESFBMRAAIBAgMGAwkAAAAAAAAAAAECABEDITFBECBRgZESIjMEYXHB 0WITQ4OEEgEAAAAAAAAAAAAAAAAAAABA/9oADAMBAAIRAxEAAACv+lahEOmxvopnxr0rEjIJdZ9c WSZAjsi8MqFtHZblGSYtpHdx7MCxBzSwAN20OQAH/9oACAECAAEFAPA//9oACAEDAAEFAPA//9oA CAEBAAEFAMEAKMeDRppWzUHpmyrJwWKnXAAjzCq/X4BYGxsYnSLhmvgJjteg/DLlGBbLNG1GM5tg jJQ/4JlBmY1UXtObNI1of0mVvY/hO1xsZMHD3tY26btEj7XPWaC1yg4JbA5WSWcNrd1dY/kwyYyb mD071z//2gAIAQICBj8AB//aAAgBAwIGPwAH/9oACAEBAQY/AIFsIT9WkDXianQYQ9hYHjCwBdRn xlDnsSwozPi90UlQKCUUATKFSoqY3qLQopPiHx2G8wqa0HKBRoNxyRoZn+T7cKVxDYwHcYE6Gf0V i9xorkdYpU1NNpZjSkazbbxNgJn7ecqILXqGPaMm+cBLjrCQ46xkst3McgIbt046DhuHzP1w+fzy 3P/Z"
                                    transform="translate(-1.709,-1.62)" overflow="visible" height="51" width="51" />
                                </g>
                              </mask>
                              <g id="g42" mask="url(#SVGID_1_)">
                                <defs id="defs27">
                                  <filter filterUnits="userSpaceOnUse" y="0.80000001" x="0.80000001" height="46.400002"
                                    width="46.400002" id="Adobe_OpacityMaskFilter_1_">
                                    <feFlood id="feFlood22" result="back" flood-opacity="1" flood-color="#fff" />
                                    <feBlend mode="normal" id="feBlend24" in2="back" in="SourceGraphic" />
                                  </filter>
                                </defs>
                                <mask maskUnits="userSpaceOnUse" y=".8" x=".8" height="46.4" width="46.4" id="mask33">
                                  <g style="filter:url(#Adobe_OpacityMaskFilter_1_)" id="g31">
                                    <image style="overflow:visible" id="image29"
                                      xlink:href="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEASABIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHCAAACRAAAAsv/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIADMAMwMBIgACEQEDEQH/ xACHAAEAAwEBAQEAAAAAAAAAAAAAAwYHAgUBBAEBAAAAAAAAAAAAAAAAAAAAABAAAgICAgICAwAA AAAAAAAAAgMBBAUGABBAESETMRIUEQABAwIEBAYDAAAAAAAAAAABABECIQMQMUESIGGRIlFxgTJC ghNDgxIBAAAAAAAAAAAAAAAAAAAAQP/aAAwDAQACEQMRAAAAz+ZohV59MkMY83Zc2PDBYtTzPUCc HNNudTMwdj9OqY37hsX2mTFjzpVCIAEnYQAA/9oACAECAAEFAPA//9oACAEDAAEFAPA//9oACAEB AAEFAOV6r7JVNTe0W6cYjdwlup3VrlZfgMAsFpoJWJVUlGSwymr2HDzTbzU6gtfQSK09FEEO2UwJ P1c05oidUoJPU/EbS0fp9xzC3f5LeGya2qEhKPcRy5cWpe15aC57nrD7C2nNTbEkDdqTA5ba/wB4 sWGWWdq4X47/AP/aAAgBAgIGPwAH/9oACAEDAgY/AAf/2gAIAQEBBj8AW21F+eiBuPXQLtcFEtui MY2o65+SiTFAMEzItEKVyAaL1GH5CHqwQYaYkFTpoVn89i2nN0G4JjkV/V1EktGRUQ+icHA1UrcD 3GmIhcJ2jIod46qkx1RjbluJ8EblwuTwH3/Rft9eD//Z"
                                      transform="translate(-1.709,-1.62)" overflow="visible" height="51" width="51" />
                                  </g>
                                </mask>
                                <linearGradient gradientUnits="userSpaceOnUse" gradientTransform="matrix(-1,0,0,1,-2075.483,0)"
                                  y2="47.771999" y1="0.171" x2="-2099.4839" x1="-2099.4839" id="SVGID_2_">
                                  <stop id="stop35" stop-color="#fff" offset="0" />
                                  <stop id="stop37" stop-color="#c1c5dc" offset="1" />
                                </linearGradient>
                                <circle style="fill:url(#SVGID_2_)" id="circle40" r="23.200001" cy="24" cx="24" />
                              </g>
                            </g>
                            <linearGradient gradientUnits="userSpaceOnUse" gradientTransform="matrix(-1,0,0,1,-2075.483,0)"
                              y2="5.7199998" y1="41.540001" x2="-2099.4829" x1="-2099.4829" id="XMLID_88_">
                              <stop id="stop45" stop-color="#fff" offset="0" />
                              <stop id="stop47" stop-color="#d9e7eb" offset="1" />
                            </linearGradient>
                            <circle style="fill:url(#XMLID_88_)" r="17.299999" cy="24" cx="24" id="XMLID_322_" />
                            <g id="XMLID_316_">
                              <defs id="defs56">
                                <filter filterUnits="userSpaceOnUse" y="7.1999998" x="7.1999998" height="33.700001"
                                  width="33.700001" id="Adobe_OpacityMaskFilter_2_">
                                  <feFlood id="feFlood51" result="back" flood-opacity="1" flood-color="#fff" />
                                  <feBlend mode="normal" id="feBlend53" in2="back" in="SourceGraphic" />
                                </filter>
                              </defs>
                              <mask maskUnits="userSpaceOnUse" y="7.2" x="7.2" height="33.7" width="33.7" id="SVGID_3_">
                                <g style="filter:url(#Adobe_OpacityMaskFilter_2_)" id="g60">
                                  <image style="overflow:visible" id="image58"
                                    xlink:href="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEASABIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGpAAAB/gAAAnT/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACcAJwMBIgACEQEDEQH/ xAB/AAADAQEAAAAAAAAAAAAAAAAABQcEBgEBAAAAAAAAAAAAAAAAAAAAABAAAgMAAQUBAAAAAAAA AAAAAwUBAgQAEDASEwYUEQABAwIEBAcAAAAAAAAAAAABABECIgMQMVEEIXGxE0GB0RKSUxQSAQAA AAAAAAAAAAAAAAAAADD/2gAMAwEAAhEDEQAAAJ+xKacIqs6Ik4yBhU4vSzqMAgORFIYWQDJSBhAP /9oACAECAAEFAOz/AP/aAAgBAwABBQDs/wD/2gAIAQEAAQUA5iS6tXJ+TL4bVOnJ0S4v1alCgdRy vD4uk47D04IC0+TmnuXzX08aTWAtLUl2q2zk0pnQ7DloGKu3Y4GfbJWPMGloGLNHc02nYlnn/9oA CAECAgY/AB//2gAIAQMCBj8AH//aAAgBAQEGPwBAt7YlPxfVEyDxGAcPGKjSmYKVKtWGpuXIhucg EQc34oNpgX0W0b77b/MISJaJzUak7hSqUNwcoXIkeUnwHYtXLkfBoyPQJvyX+fbn6J9xC5AaGMh1 w//Z"
                                    transform="translate(4.291,4.38)" overflow="visible" height="39" width="39" />
                                </g>
                              </mask>
                              <g id="g70" mask="url(#SVGID_3_)">
                                <linearGradient gradientUnits="userSpaceOnUse" gradientTransform="matrix(-1,0,0,1,-2075.483,0)"
                                  y2="41.630001" y1="6.2480001" x2="-2099.4839" x1="-2099.4839" id="SVGID_4_">
                                  <stop id="stop63" stop-color="#f2f6f9" offset="0" />
                                  <stop id="stop65" stop-color="#f2f3f4" offset="1" />
                                </linearGradient>
                                <circle style="fill:url(#SVGID_4_)" id="circle68" r="16.799999" cy="24" cx="24" />
                              </g>
                            </g>
                          </g>
                          <g id="icon">
                            <path inkscape:connector-curvature="0" d="M 18.8,17 V 31 L 30.7,24 Z" id="XMLID_82_" />
                          </g>
                        </g>
                      </svg>
                    </div>
                  </router-link>
                </button>
    </v-layout>
</template>

<script>
import ScormMix from '../js/mixins/scormmixins'
import resourcesLoader from "../js/mixins/resources-loader";
export default {
    mixins: [resourcesLoader],
    props: {
        mod: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            titulo: '',
            // logo: '',
        }
    },
    methods: {
        getData(data) {
            return data
        },
        getModuleTitle() {
            return this.$store.state.title
        },
        scrolltop() {
            //this.$refs.toolbarChat.scrollTop = -1000;
            window.scrollTo(0, 0)
        }
    },
    computed: {
        temaName() {
            return this.$store.state.tema;
        },
        subtemaName() {
            console.log('SUBTEMANAME ' + this.$store.state.subTema)
            return this.$store.state.subTema;
        },
        showTrack() {
            var routeArr = this.$route.path.split("/");
            console.log('routerArr ' + routeArr)
            if (routeArr.length <= 2) {
                return false
            } else {
                return true
            }
        },
        currentPage() {
            return Math.floor(this.$route.params.unipage);
        },
        nextPant() {
            return this.$store.state.nextPant;
        },
        screenTrack() {
            return this.$store.state.screens;
        },
        currentPage() {
            return Math.floor(this.$route.params.unipage);
        }
    },
    watch: {
        screenTrack(val) {
            let bar = this.$refs['progressBar']
            let pct = ((val[0] + 1) / val[1]) * 100
            console.log('pct: ' + pct)
            bar.style.width = pct + "%"
        }
    },
    mixins: [ScormMix]
}
</script>

<style lang="scss" scoped>
@import '../sass/globals';
*:focus {
    outline: none !important;
}

a {
    text-decoration: none !important;
    color: white;
}

.inactive {
    opacity: 0;
    pointer-events: none;
    &:hover {
        cursor: none !important;
    }
}

.navmenu-container {
    width: 100%;
    height: 50px;
    position: fixed;
    bottom: 0px;
    background: #F7F8F9;
    z-index: 3;
    color: $color-complement-one;
}

.progress-container {
    width: 100%;
    height: auto;
    .page-count {
        width: 100%;
        position: relative;
        padding: 0;
        margin: 0;
        height: 10px;
        font-size: 8pt;
        line-height: 0pt;
        text-align: center;
        span {
            padding: 0;
            margin: 0;
        }
    }
    .progress-bar {
        width: 95%;
        height: 15px;
        background: $color-inverted;
        border: solid 2px #E2E4EE;
        border-radius: 10px;
        position: relative;
        overflow: hidden;
        margin: 0 auto;
        .bar {
            display: block;
            position: absolute;
            height: 100%;
            bottom: 0%;
            left: 0%;
            background: rgb(11, 12, 111);
            background: linear-gradient(90deg, rgba(11, 27, 111, 1) 0%, rgba(14, 221, 227, 1) 100%); //background-color: $color-primary;
            max-width: 100%;
            transition: width 200ms;
        }
    }
    @media screen and (min-width: 700px) {
        width: 50%;
    }
}

.btn-nav {
    cursor: pointer;
    .icon {
        width: 56px;
    }
    #icon {
        fill: #7e8a9a;
    }
    &:hover {
        a {
            #icon {
                fill: rgba(14, 221, 227, 1);
            }
        }
    }
}
</style>